export default class Flip {
  constructor(element) {
    this.element = element;
    this.togglers = this.element.querySelectorAll(".js-flip-button");
    this.front = this.element.querySelector(".js-flip-front");
    this.back = this.element.querySelector(".js-flip-back");
    this.frontButtons = this.element.querySelectorAll(".js-flip-front .c-button, .js-flip-front .c-title__mainlink");
    this.backButtons = this.element.querySelectorAll(".js-flip-back .c-button, .js-flip-back .c-title__mainlink");

    this.handleToggleCard = this.handleToggleCard.bind(this);
  }

  mount() {
    this.togglers.forEach((element) => {
      element.addEventListener('click', this.handleToggleCard);
    });
  }

  handleToggleCard() {

    this.element.classList.toggle("is-fliped");

    if (this.element.classList.contains("is-fliped")) {
      for (let i = 0; i < this.frontButtons.length; i++) {
        const element = this.frontButtons[i];
        element.setAttribute("tabindex",-1);
      }
      for (let i = 0; i < this.backButtons.length; i++) {
        const element = this.backButtons[i];
        element.setAttribute("tabindex",0);
      }
    } else {
      for (let i = 0; i < this.frontButtons.length; i++) {
        const element = this.frontButtons[i];
        element.setAttribute("tabindex",0);
      }
      for (let i = 0; i < this.backButtons.length; i++) {
        const element = this.backButtons[i];
        element.setAttribute("tabindex",-1);
      }
    }
  }
}
